// Subscription Service
import {
  appSubscriptionTierFromStored,
  type SubscriptionTier,
} from '../utils/subscriptionTier';

export type { SubscriptionTier };

export const subscriptionService = {
  getTiers: () => {
    return [
      { id: 'free', name: 'Free', price: 0 },
      { id: 'monthly', name: 'Monthly', price: 20 },
      { id: 'lifetime', name: 'Lifetime', price: 97 }
    ];
  },

  getTier: (): SubscriptionTier => {
    return appSubscriptionTierFromStored(localStorage.getItem('subscriptionTier'));
  },

  upgradeToWeekly: async () => {
    const { paymentService } = await import('./paymentService');
    const result = await paymentService.createCheckoutSession('weekly');
    if (result.success) return { success: true };
    return { success: false, error: result.error };
  },

  upgradeToMonthly: async () => {
    const { paymentService } = await import('./paymentService');
    const result = await paymentService.createCheckoutSession('monthly');
    if (result.success) return { success: true };
    return { success: false, error: result.error };
  },

  upgradeToLifetime: async () => {
    const { paymentService } = await import('./paymentService');
    const result = await paymentService.createCheckoutSession('lifetime');
    if (result.success) return { success: true };
    return { success: false, error: result.error };
  },

  upgradeToGo: async () => {
    return subscriptionService.upgradeToMonthly();
  },

  upgradeToPro1Month: async () => {
    return subscriptionService.upgradeToMonthly();
  },

  upgradeToPro3Months: async () => {
    return subscriptionService.upgradeToMonthly();
  },

  hasActiveSubscription: (): boolean => {
    const tier = subscriptionService.getTier();
    return tier === 'weekly' || tier === 'monthly' || tier === 'lifetime';
  }
};
